<div class="wrapper  " *ngIf="showResult">
    <div class="modal-header" *ngIf="!noList">
        <h6 class="sub-header-text">Match Results: {{ totalResult }}</h6>
    </div>
    <div class="modal-header" *ngIf="noList">
        <h6 class="sub-header-text">No Match Found!!</h6>
    </div>
    <div class="modal-body mb-1 p-4 result-scroll" *ngIf="!noList">
        <div class="search-contents" [hidden]='!loading'>
            <div class="col-sm-12 col-md-12">
                <div class="loader-wrapper">
                    <div class="loader-img">
                    </div>
                    <h5>Please wait!</h5>
                    <p>We are loading content for you...</p>
                </div>
            </div>
        </div>
        <!--<div *ngFor='let result of staticlist' class="row col-sm-12 col-md-12 border-bottom pt-2">
            <div class="col-10 col-md-11 p-0">
               <label class="check-box">
                  <input class="chk-static-college" value="{{ result.id }}" type="checkbox" checked>
                  <span class="checked1"></span>
                  <ul class="uni-list">
                     <li class="uni-name">{{ result.college_name }}</li>
                     <li *ngIf="result.access_level == 'Patriot'">
                        <span class="partner-class">
                            <i class="fa fa-handshake"></i>
                            <strong>Partner School</strong>
                        </span>
                    </li>
                  </ul>
               </label>
            </div>
            <div class="col-2 col-md-1">
              <div class="bluecircle small" [attr.data-percent]="100">
              </div>
              <label class="matched-text">matched</label>
           </div>
        </div> 
        <br>-->
        <div *ngFor='let result of (topData | slice:0:sliceNumber);let i = index' class="row col-sm-12 col-md-12">
            <div class="col-10 col-md-11 p-0">
                <label class="check-box">
                    <input *ngIf="result.percentMatch > 0" [hidden]="!result.collegeContact" class="chk-college" value="{{ result.collegeId }}"
                        type="checkbox" checked>
                    <span class="checked1" [hidden]="!result.collegeContact"></span>
                    <ul class="uni-list">
                        <li class="uni-name">{{ result.college_name }}</li>
                        <!--<li class="state">{{ result.city }}, {{ result.state }}</li>-->
                        <li *ngIf="result.accessLevel == 'Patriot'">
                            <span class="partner-class">
                                <i class="fa fa-handshake"></i>
                                <strong>Partner School</strong>
                            </span>
                        </li>
                    </ul>
                </label>
            </div>
            <div class="col-2 col-md-1">
                <div class="bluecircle small" [attr.data-percent]="result.percentMatch">
                </div>
                <label class="matched-text">matched</label>
            </div>

        </div>
        <div *ngIf="!emptyPassedCollege" class="seperator-line">
            <h1>Other Matching Schools</h1>
          </div>
        <div *ngFor='let result of (resultData | slice:0:sliceNumber);let i = index' class="row col-sm-12 col-md-12"
            [ngClass]="i==0?'':'border-top pt-2'">
            <div class="col-10 col-md-11 p-0">
                <label class="check-box">
                    <input *ngIf="result.percentMatch > 0" [hidden]="!result.collegeContact" class="chk-college" value="{{ result.collegeId }}"
                        type="checkbox" [checked]="result.checkNonPartner || result.checkPartner">
                    <span class="checked1" [hidden]="!result.collegeContact"></span>
                    <ul class="uni-list">
                        <li class="uni-name">{{ result.college_name }}</li>
                        <!--<li class="state">{{ result.city }}, {{ result.state }}</li>-->
                        <li *ngIf="result.accessLevel == 'Patriot'">
                            <span class="partner-class">
                                <i class="fa fa-handshake"></i>
                                <strong>Partner School</strong>
                            </span>
                        </li>
                    </ul>
                </label>
            </div>
            <div class="col-2 col-md-1">
                <div class="bluecircle small" [attr.data-percent]="result.percentMatch">
                </div>
                <label class="matched-text">matched</label>
            </div>
        </div>
        <div *ngIf="showMore" class="loadmore-btn text-center mt-2">
            <a href="javascript:void(0)" (click)="loadMoreData()" id="loadMore">
                <label for="">Show More</label>
                <i class="fas fa-angle-down"></i>
            </a>
        </div>

    </div>

    <div class="modal-footer m-footer flex-column">
        <div class="d-flex justify-content-between w-100">
            <a href="javascript:void(0)" (click)="skipNow()" class="pl-2 " role="button">
                skip for now</a>
            <a id="requestinfo" *ngIf="!noList" href="javascript:void(0)" (click)="requestInfo()" class="btn btn-next "
                role="button">
                <i [hidden]='envelope' class="fas fa-spinner fa-pulse"></i> <i [hidden]='spinner'
                    class="fas fa-envelope"></i>
                &nbsp;Request Info
            </a>
        </div>
        <div id="footer" class="text-center mt-4">
            <p>© {{ _parent.year }} CollegeRecon. All rights reserved.</p>
        </div>
    </div>
</div>
<!-- Modal box-->
<div class="modal fade" id="messageModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content content-box connect-content">
            <div class="boxes majors" id="majors">
                <div class="box-header modal-header">
                    <h4 class="modal-title">Message Info::</h4>
                    <button type="button" class="btn btn-default" data-dismiss="modal"><span
                            aria-hidden="true">x</span></button>
                </div>
                <div *ngIf="successMessage" id="connectsuccessMessage"> {{ messageInfo }} </div>
                <div *ngIf="showMessage" class="message-sending"> Sending Message to Colleges....</div>
                <form id="connetdataForm" (ngSubmit)="f.form.valid && messagesubmit()" #f="ngForm" novalidate>
                    <div class="modal-body content {{formClass}}">
                        <div id="message-form" class="msg-popup">
                            <div class="form-group">
                                <textarea class="form-control" [(ngModel)]="_parent.model.student_message"
                                    id="student-message" name="student_message" rows="5"></textarea>
                            </div>
                            <div class="form-group">
                                Want to get started writing your message? Select from one of the preset messages below.
                            </div>
                            <div class="form-group">
                                <select class="form-control sel-opt" [(ngModel)]="_parent.model.message_type"
                                    name="message_type" id="canned-messages" (change)="cannedMessage()" required>
                                    <option value=""></option>
                                    <option value="APPLICATIONHELP">Application Help</option>
                                    <option value="PHONECALL">Phone Call</option>
                                    <option value="GENERALQUESTIONS">General Questions</option>
                                    <option value="NEXTSTEPS">Next Steps</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">

                        <button type="button" class="btn btn-next" (click)="clickSubmit(f.form.valid)"><i
                                class="fa fa-paper-plane-o" aria-hidden="true"></i>
                            Send</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="phoneNumberMessageModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content content-box connect-content">
        <div class="boxes majors" id="majors">
          <div class="box-header">
            <h4 class="modal-title">Additional Information</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                aria-hidden="true">x</span></button>
          </div>
          <div>
            <div class="modal-body-part">
                <div *ngIf="!this.veteranPhone">
                <p> The following school(s) request a phone number from you to best respond to your inquiry. Please fill out the phone number and press submit.</p>
                <input type="tel" class="form-control" name="phone" id="modalphone" placeholder="Phone Number"/>
                <div *ngIf="checkedColleges">
                    <ng-container *ngFor="let result of resultData">
                        <li *ngIf="result.phoneRequired === 'yes' && collegeChecked(result.collegeId)">
                            {{ result.college_name }}
                        </li>
                      </ng-container>                      
                </div>
            </div>
                <div *ngIf="snhuChecked">
                    <!-- form goes here -->

                    <div id="trustedFormOffer">
                        <form #form="ngForm" data-tf-element-role="offer">
                          <div class="text-start p-4 flex flex-col">
                
                            <input type="hidden" [(ngModel)]="formData.trustedform_cert_url" name="xxTrustedFormCertUrl" />
                            <input type="hidden" name="xxTrustedFormPingUrl" />
                            <label for="snhuCheckbox" data-tf-element-role="consent-language">
                              <input type="checkbox" [(ngModel)]="snhuTOAChecked" name="consent-opt-in"
                                data-tf-element-role="consent-opt-in" data-tf-element-role="Hidden SNHU Consent" />
                              By clicking “Get Info”, I provide my elec. sig. and agree to receive marketing emails, phone calls,
                              and text
                              (SMS/MMS) messages from <span data-tf-element-role="consent-advertiser-name">Southern New Hampshire
                                University (SNHU)</span> at the number I provided above including
                              automated calls or texts made using prerecorded and/or artificial voice messages. This consent is not
                              required
                              to purchase services, you may also call SNHU at 800.668.1249. <a
                                href="https://www.snhu.edu/privacy-policy/sms-terms-and-conditions">SMS Terms and Conditions</a>
                              apply.
                            </label>
                            <hr class="mt-2">
                            <div class="modal-footer">
                              <button class="btn" type="button"
                                (click)="skipPhoneNumber()">Skip</button>
                              <button class="btn btn-next" type="button" id="hiddenSubmitButton"
                                data-tf-element-role="submit" (click)="submitPhoneNumber()">Get Info</button>
                            </div>
                          </div>
                        </form>
                      </div>
                </div>
            </div>
            <div class="modal-footer" *ngIf="!snhuChecked">
              <button type="button" class="btn" (click)="skipPhoneNumber()">
                Skip
              </button>
              <button type="button" class="btn btn-next" (click)="submitPhoneNumber()">
                <i class="fa" [ngClass]='{"fa-spinner fa-pulse": saving, "fa-envelope": !saving}'></i>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/result/result.component.html